/**
 * Hook que verifica periódicamente si hay una nueva versión disponible y muestra modal.
 */
import { useState, useEffect } from "react";
import { useAuth } from "AuthContext";
import { GETCheckVersion } from "helpers/version/GETVersionCheck";
import { logger } from "utils/logger";

// persiste entre montajes del componente, se reinicia con refresh
let _versionCheckExecuted = false;

export const useAppVersion = () => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  // Estados de las versiones (base de datos)
  const [backendVerfro, setBackendVerfro] = useState(null);
  const [backendVerbac, setBackendVerbac] = useState(null);

  const { loggedUser } = useAuth();

  const checkVersion = async () => {
    if (showUpdateModal || isChecking || _versionCheckExecuted) return;

    setIsChecking(true);

    try {
      const currentVersion = process.env.REACT_APP_VERSION || null;
      const standarVersion = currentVersion?.replace("v", "").trim() || "N/A";

      const result = await GETCheckVersion(loggedUser, standarVersion);

      if (result?.status === 200 && result?.data) {
        const backendVersion = result.data.versionBE?.trim();
        const clientVersion = result.data.versionFE?.trim();
        const coincidenVersiones = result.data.coincidenVersiones;

        setBackendVerbac(backendVersion || "N/A");
        setBackendVerfro(clientVersion || "N/A");

        _versionCheckExecuted = true;

        if (coincidenVersiones === false) {
          setShowUpdateModal(true);
        }
      }
    } catch (error) {
      logger.warn("Error no capturado verificando versión de OneFIN", error);
    } finally {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    const isUserLogged = loggedUser && Object.keys(loggedUser).length > 0;
    if (!isUserLogged) return;

    if (!_versionCheckExecuted) {
      const timer = setTimeout(() => {
        checkVersion();
      }, 500);

      const handleVisibilityChange = () => {
        if (!document.hidden && !_versionCheckExecuted) {
          checkVersion();
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        clearTimeout(timer);
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser]);

  const clearSession = () => {
    _versionCheckExecuted = false;

    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });

    localStorage.removeItem("userWMS");

    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith("auditarSma_filtro_")) {
        localStorage.removeItem(key);
      }
    });
  };

  const handleUpdate = () => {
    clearSession();
    window.location.reload(true);
  };

  return {
    showUpdateModal,
    handleUpdate,
    backendVerbac,
    backendVerfro,
  };
};
